import React from 'react';
import { hannah, hannahPortrait } from '../data/content';
import useCountUp from '../hooks/useCountUp';

export default function Hannah() {
  const { ref: yearsRef, display: years } = useCountUp(15);
  return (
    <section id="hannah" className="relative py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden relative bg-[#E3DBD1]" data-reveal="image">
              <img
                src={hannahPortrait}
                alt="Hannah Hulley, founder of Founder Growth Collective"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 hidden lg:block bg-[#EBE4DE] px-6 py-5 border-l-2 border-[#B5876C] max-w-[240px]" data-reveal style={{ '--reveal-delay': '360ms' }}>
              <p className="font-serif italic text-sm text-[#57534b] leading-snug">Founder & operator behind Founder Growth Collective.</p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pt-8">
          <p className="sec-num text-sm tracking-[0.3em] uppercase" data-reveal>/ 06</p>
          <p className="mt-6 text-[13px] tracking-[0.24em] uppercase text-[#7a7369]" data-reveal style={{ '--reveal-delay': '80ms' }}>Meet your strategic partner</p>
          <h2 className="mt-4 font-serif text-[40px] lg:text-[64px] leading-[1.0] tracking-[-0.02em] text-[#2E2C28] font-light" data-reveal style={{ '--reveal-delay': '160ms' }}>
            {hannah.name}
            <span className="block text-[#B5876C] italic text-3xl lg:text-4xl mt-4">{hannah.role}</span>
          </h2>
          <p className="mt-10 text-lg lg:text-xl leading-[1.65] text-[#4a463f] font-light max-w-2xl" data-reveal style={{ '--reveal-delay': '280ms' }}>
            {hannah.bio}
          </p>

          <div className="mt-12 grid grid-cols-2 gap-8 max-w-lg border-t border-[#d9d2ca] pt-8">
            <div data-reveal="up-sm" style={{ '--reveal-delay': '380ms' }}>
              <p ref={yearsRef} className="font-serif text-3xl text-[#2E2C28] font-light">{Math.round(years)}+</p>
              <p className="mt-2 text-[11px] tracking-[0.22em] uppercase text-[#7a7369]">Years in B2B sales</p>
            </div>
            <div data-reveal="up-sm" style={{ '--reveal-delay': '460ms' }}>
              <p className="font-serif text-3xl text-[#2E2C28] font-light">Series C</p>
              <p className="mt-2 text-[11px] tracking-[0.22em] uppercase text-[#7a7369]">UK expansion led</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
